// extracted by mini-css-extract-plugin
var _1 = "WidgetHeaderSkeleton-moduleWidgetHeaderSkeleton__THT6z Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "WidgetHeaderSkeleton" }
